export const BASE_URL = process.env.REACT_APP_API_ENDPOINT;

export const AUTHENTICATION = {
  GET_USER_INFO: `${BASE_URL}/account/getUser`,
  AUTH_LOGIN: `${BASE_URL}/api/login`,
  AUTH_LOGOUT: `${BASE_URL}/api/logout`,
  AUTH_REGISTER: `${BASE_URL}/register/save`,
  GET_USERS: `${BASE_URL}/account/getUsers`,
  PROCESS_RFID: `${BASE_URL}/account/processRFID`,
  DELETE_RFID: `${BASE_URL}/account/deleteRfid`,
  REGISTER_RFID: `${BASE_URL}/account/registerRfid`,
  GET_EMPLOYEES: `${BASE_URL}/account/getAllEmployees`,
  GET_ONLINE_EMPLOYEES: `${BASE_URL}/account/getOnlineEmployee`,
};

export const USER_MANAGEMENT = {
  FIND_USERS: `${BASE_URL}/team/fetchLinkedUsers`,
  UPDATE_USER: `${BASE_URL}/team/update`,
  DELETE_USER: `${BASE_URL}/team/delete`,
  GET_ROLES: `${BASE_URL}/team/getRoles`,
  GET_LOCATION_DETAIL: `${BASE_URL}/team/getLocationPeople`,
};
export const DASHBOARD = {
  MATCH_POINT_REPORT_PDF: `${BASE_URL}/report/previewMatchPointReport`,
  MACHINE_TICKET_REPORT_PDF: `${BASE_URL}/report/previewMachineTicketReport`,
  MASTER_READING_REPORT_PDF: `${BASE_URL}/report/previewMasterReadingReport`,
};

export const ALERTS = {
  FETCH_ALERTS: `${BASE_URL}/alert/listAlerts`,
  FETCH_ALERT_SUMMARY: `${BASE_URL}/alert/alertSummary`,
  RESOLVE_ALERT: `${BASE_URL}/alert/resolveAlert`,
  DELETE_ALL_ALERTS: `${BASE_URL}/alert/deleteAllAlerts`,
};

export const ACCOUNT = {
  GET_USER_SETTING: `${BASE_URL}/account/getUserSetting`,
  SAVE_USER_SETTING: `${BASE_URL}/account/saveUserSetting`,
};

// Cross-company location access requests. Granting an employee access at
// a location another company owns raises one of these instead of applying
// the change; that location's owner approves or declines it.
export const ACCESS_REQUESTS = {
  LIST_INCOMING: `${BASE_URL}/accessRequest/listIncoming`,
  LIST_OUTGOING: `${BASE_URL}/accessRequest/listOutgoing`,
  PENDING_FOR_USERS: `${BASE_URL}/accessRequest/pendingForUsers`,
  APPROVE: `${BASE_URL}/accessRequest/approve`,
  REJECT: `${BASE_URL}/accessRequest/reject`,
  CANCEL: `${BASE_URL}/accessRequest/cancel`,
  REVOKE: `${BASE_URL}/accessRequest/revoke`,
};

export const CUSTOMER = {
  LIST_ALL_CUSTOMER: `${BASE_URL}/customer/list`,
  SAVE_CUSTOMER: `${BASE_URL}/customer/save`,
  DELETE_CUSTOMER: `${BASE_URL}/customer/delete`,
  ADD_FILES: `${BASE_URL}/customer/addFiles`,
  DELETE_FILES: `${BASE_URL}/customer/deleteFiles`,
  PREVIEW_FILE: `${BASE_URL}/customer/previewFile`,
  LIST_CUSTOMER_POINTS: `${BASE_URL}/customer/customerPointsList`,
  LIST_CUSTOMER_PENDING: `${BASE_URL}/customer/customerPendingList`,
  DELETE_CUSTOMER_PENDING: `${BASE_URL}/customer/deleteCustomerPending`,
  PREVIEW_IMAGE: `${BASE_URL}/customer/previewImage`,
  SET_CUSTOMER_TICKET: `${BASE_URL}/customer/setTicket`,
  PREVIEW_VIP_PHOTO: `${BASE_URL}/customer/previewVipPhoto`,
  SET_CUSTOMER_POINTS: `${BASE_URL}/customer/setPoints`,
  ENROLL_CUSTOMER: `${BASE_URL}/customer/enrollCustomer`,
  RAFFLE_CUSTOMERS: `${BASE_URL}/customer/searchByCustomerName`,
  GET_POINT_WATCHING: `${BASE_URL}/customer/customerPendingByUserAndDate`,
  POINT_WATCHING_BY_DATE: `${BASE_URL}/customer/pointWatchingByDate`,
  POINT_WATCHING_DAY_ENTRIES: `${BASE_URL}/customer/pointWatchingDayEntries`,
  POINT_WATCHING_EMPLOYEE_DAYS: `${BASE_URL}/customer/pointWatchingEmployeeDays`,
  POINT_WATCHING_ALERTS: `${BASE_URL}/customer/pointWatchingAlerts`,
  CLEAR_POINT_WATCHING_ALERT: `${BASE_URL}/customer/clearPointWatchingAlert`,
  PREVIEW_POINT_WATCHING_IMAGE: `${BASE_URL}/customer/previewPointWatchingImage`,
  GET_POINT_HISTORY: `${BASE_URL}/customer/getCustomerHistory`,
  GET_RECENT_VISITS: `${BASE_URL}/customer/getHistory`,
  VALIDATE_CUSTOMER_NAME: `${BASE_URL}/customer/validateCustomer`,

  LIST_ALL_HISTORICAL_CUSTOMER: `${BASE_URL}/customer/listArchieveCustomer`,
  RESTORE_HISTORICAL_CUSTOMER: `${BASE_URL}/customer/restoreCustomer`,
};

export const TICKET_OUT = {
  LIST_ALL_TICKET_OUT: `${BASE_URL}/ticketOut/list`,
  SAVE_TICKET_OUT: `${BASE_URL}/ticketOut/save`,
  DELETE_TICKET_OUT: `${BASE_URL}/ticketOut/delete`,
  GET_PHOTO_SETTING: `${BASE_URL}/ticketOut/getPhotoSetting`,
  SAVE_PHOTO_SETTING: `${BASE_URL}/ticketOut/savePhotoSetting`,
  PREVIEW_PHOTO: `${BASE_URL}/ticketOut/previewPhoto`,
};

export const TRANSACTION = {
  LIST_ALL_TRANSACTION: `${BASE_URL}/transaction/list`,
  SAVE_TRANSACTION: `${BASE_URL}/transaction/save`,
  DELETE_TRANSACTION: `${BASE_URL}/transaction/delete`,
  CASH_LEFT: `${BASE_URL}/transaction/saveCashLeft`,
  ROLLOVER: `${BASE_URL}/transaction/rollover`,
  ROLLOVER_REQUEST: `${BASE_URL}/transaction/listPendingTransfers`,
  LIST_CATEGORY: `${BASE_URL}/transaction/listCategory`,
  EDIT_CATEGORY: `${BASE_URL}/transaction/editCategory`,
  PREVIEW_PHOTO: `${BASE_URL}/transaction/previewPhoto`,
  SHIFT_HISTORY: `${BASE_URL}/transaction/shiftHistory`,
};

export const REPORT = {
  GLOBAL_PDF: `${BASE_URL}/report/`,
  LIST_REPORT: `${BASE_URL}/report/weeklyReport`,
  UPDATE_REPORT_FIELD: `${BASE_URL}/report/updateReportField`,
  UPDATE_MANAGER_BANK: `${BASE_URL}/report/updateManagerBank`,
  EDIT_BANK_BOARD_ENTRY: `${BASE_URL}/report/editBankBoardEntry`,
  DELETE_BANK_BOARD_ENTRY: `${BASE_URL}/report/deleteBankBoardEntry`,
  GET_MANAGER_SUMMARY: `${BASE_URL}/report/getManagerSummaryByLocation`,
  SAVE_MANAGER_SUMMARY: `${BASE_URL}/report/saveManagerSetting`,
  UPDATE_MANAGER_SUMMARY: `${BASE_URL}/report/updateManagerSummary`,
  SHORT_ANALYSIS: `${BASE_URL}/report/shortAnalysis`,
};

export const COMPANY = {
  LIST_COMPANIES: `${BASE_URL}/company/list`,
  LIST_AVAILABLE_COMPANIES: `${BASE_URL}/company/listAvailableCompanies`,
  CREATE_COMPANY: `${BASE_URL}/company/create`,
  UPDATE_COMPANY: `${BASE_URL}/company/update`,
  LIST_MASTER_ADMIN: `${BASE_URL}/company/getMasterAdmins`,

  GENERATE_LICENSE: `${BASE_URL}/company/createLicenseKey`,
  ACTIVATE_LICENSE: `${BASE_URL}/company/activateCompanyWithKey`,
  GET_LICENSE: `${BASE_URL}/company/viewCompanyLicenseKey`,
  RENEW_LICENSE: `${BASE_URL}/company/renewLicenseKey`,
  REVOKE_LICENSE: `${BASE_URL}/company/revokeLicenseKey`,
  LIST_ACTIVE_LICENSE: `${BASE_URL}/company/getLicenseHistory`,

  UPDATE_LICENSE_AMOUNT: `${BASE_URL}/company/updateLicenseAmount`,
  ACTUAL_PROJECTION: `${BASE_URL}/company/getActualMembership`,
  YEARLY_PROJECTION: `${BASE_URL}/company/getYearlyProjections`,
  GET_COMPANY_MEMBERSHIPS: `${BASE_URL}/company/getCompanyMemberships`,
  LIST_LICENSE_PAYMENTS: `${BASE_URL}/company/listLicensePayments`,
  UPDATE_LICENSE_PAYMENT: `${BASE_URL}/company/updateLicensePayment`,
  RECORD_NEXT_CYCLE_PAYMENT: `${BASE_URL}/company/recordNextCyclePayment`,
  MARK_CYCLE_PAID: `${BASE_URL}/company/markCyclePaid`,
  SET_AUTO_RENEWAL: `${BASE_URL}/company/setAutoRenewal`,
  SET_BILLING_DURATION: `${BASE_URL}/company/setBillingDuration`,
  // Subscription page > Manage subscription — a plan switch is scheduled
  // for the next billing date, never applied mid-cycle.
  SCHEDULE_PLAN_CHANGE: `${BASE_URL}/company/schedulePlanChange`,
  CANCEL_PLAN_CHANGE: `${BASE_URL}/company/cancelPlanChange`,
};

export const UUID = {
  GET_UUID: `${BASE_URL}/uuid/getUUID`,
  GET_UUIDS: `${BASE_URL}/uuid/getUUIDs`,
};

// NDS Phone Verification. Every action requires an authenticated employee
// and is driven from the NuVePad tablet.
export const VERIFICATION = {
  SEND_CODE: `${BASE_URL}/verification/sendCode`,
  VERIFY_CODE: `${BASE_URL}/verification/verifyCode`,
  RESEND_CODE: `${BASE_URL}/verification/resendCode`,
};

// Phase 2 — Stripe. PUBLIC_CONFIG / PAY_AND_ACTIVATE_FROM_KEY / PAY_NOW_STATUS
// are server-side permitAll (used by the locked-out Login Pay flow). The
// rest require ROLE_OWNER / ROLE_TECH_ADMIN / ROLE_MASTER_ADMIN.
export const STRIPE = {
  PUBLIC_CONFIG: `${BASE_URL}/stripe/publicConfig`,
  CREATE_SETUP_INTENT: `${BASE_URL}/stripe/createSetupIntent`,
  CREATE_PAY_NOW: `${BASE_URL}/stripe/createPayNow`,
  PAY_AND_ACTIVATE_FROM_KEY: `${BASE_URL}/stripe/payAndActivateFromKey`,
  PAY_NOW_STATUS: `${BASE_URL}/stripe/payNowStatus`,
  UPDATE_SAVE_PREFERENCE: `${BASE_URL}/stripe/updateSavePreference`,
  QUOTE_FEE: `${BASE_URL}/stripe/quoteFee`,
  LIST_SAVED_CARDS: `${BASE_URL}/stripe/listSavedCards`,
  DETACH_PAYMENT_METHOD: `${BASE_URL}/stripe/detachPaymentMethod`,
  SET_DEFAULT_CARD: `${BASE_URL}/stripe/setDefaultCard`,
};

// Customer onboarding. CHECKOUT / STATUS are server-side permitAll (the public
// landing-page sign-up wizard runs anonymously). The rest power the technician
// "Onboarding Requests" panel inside Manage Company and require admin roles.
export const ONBOARDING = {
  CHECKOUT: `${BASE_URL}/onboarding/checkout`,
  STATUS: `${BASE_URL}/onboarding/status`,
  LIST_REQUESTS: `${BASE_URL}/onboarding/listRequests`,
  GET_REQUEST: `${BASE_URL}/onboarding/requestDetails`,
  UPDATE_REQUEST: `${BASE_URL}/onboarding/updateRequest`,
  ACTIVATE: `${BASE_URL}/onboarding/activate`,
  SEND_WELCOME: `${BASE_URL}/onboarding/sendWelcome`,
  CHECK_USERNAME: `${BASE_URL}/onboarding/checkUsername`,
  INVOICE: `${BASE_URL}/onboarding/invoice`,
};

// Plans & Pricing (Manage Company). PUBLIC_CATALOG is permitAll — the landing
// page and the anonymous sign-up wizard price themselves off the same rate
// card the back office edits, so the two can never disagree. Every other
// action is ROLE_OWNER: defining a plan is NDS platform work.
export const PLAN_CATALOG = {
  PUBLIC_CATALOG: `${BASE_URL}/planCatalog/publicCatalog`,
  OVERVIEW: `${BASE_URL}/planCatalog/overview`,
  PREVIEW_CHANGES: `${BASE_URL}/planCatalog/previewChanges`,
  PUBLISH: `${BASE_URL}/planCatalog/publish`,
  APPLY_PENDING_NOW: `${BASE_URL}/planCatalog/applyPendingNow`,
  SET_CUSTOM_RATE: `${BASE_URL}/planCatalog/setCustomRate`,
};

// Manage Company > Discount Groups — which companies share the
// multi-location discount. LIST is readable by whoever can open the company
// wizard (it prices a location by its group); every change is ROLE_OWNER.
export const DISCOUNT_GROUP = {
  LIST: `${BASE_URL}/discountGroup/list`,
  CREATE: `${BASE_URL}/discountGroup/create`,
  RENAME: `${BASE_URL}/discountGroup/rename`,
  ADD_COMPANY: `${BASE_URL}/discountGroup/addCompany`,
  REMOVE_COMPANY: `${BASE_URL}/discountGroup/removeCompany`,
  DELETE: `${BASE_URL}/discountGroup/deleteGroup`,
};

export const MACHINE = {
  LIST_MACHINE: `${BASE_URL}/machine/list`,
  EDIT_MACHINE: `${BASE_URL}/machine/edit`,
  LIST_ASSIGN_MACHINE: `${BASE_URL}/machine/listAssignTemplates`,
  EDIT_ASSIGN_MACHINE: `${BASE_URL}/machine/assignMachineToGame`,
  UPDATE_READING: `${BASE_URL}/machine/updateReading`,
  LIST_READING: `${BASE_URL}/machine/listReading`,
  LIST_MATCH_TICKETS: `${BASE_URL}/machine/matchTickets`,
  LIST_SESSION_ID: `${BASE_URL}/machine/getSessionIds`,
  ADD_MACHINE_PICTURE: `${BASE_URL}/machine/addMachinePicture`,
  LIST_MACHINE_PICTURE: `${BASE_URL}/machine/listMachinePicture`,
  DELETE_MACHINE_PICTURE: `${BASE_URL}/machine/deleteMachinePicture`,
  AVAILABLE_EMPLOYEE_SESSION: `${BASE_URL}/machine/getAvailableEmployeeSessions`,
  START_SESSION: `${BASE_URL}/machine/startNewSession`,
  END_SESSION: `${BASE_URL}/machine/endSession`,
  AUDIT_STATUS: `${BASE_URL}/machine/auditStatus`,
  CANCEL_SESSION: `${BASE_URL}/machine/cancelSession`,
  LOAD_STARTED_SESSION: `${BASE_URL}/machine/loadStartedSession`,
  RESET_MACHINE: `${BASE_URL}/machine/resetMachine`,
  GET_PREV_IN_OUT: `${BASE_URL}/machine/getPreviousInAndOutReading`,
  OPEN_LAST_READING_SESSION: `${BASE_URL}/machine/openReadingSession`,
  GET_LAST_TWO_READING_SESSION: `${BASE_URL}/machine/getLastTwoReadingSessions`,
  LIST_DELETED_READING_SESSIONS: `${BASE_URL}/machine/listDeletedReadingSessions`,
  RESTORE_READING_SESSION: `${BASE_URL}/machine/restoreReadingSession`,
  DELETE_FOREVER_READING_SESSION: `${BASE_URL}/machine/deleteForeverReadingSession`,
};

export const CLOCK = {
  CLOCK_IN: `${BASE_URL}/clock/clockIn`,
  CLOCK_OUT: `${BASE_URL}/clock/clockOut`,
  FORCE_CLOCK_OUT: `${BASE_URL}/clock/forceClockOut`,
  LOAD_CLOCK_RECORD: `${BASE_URL}/clock/loadClockRecords`,
  LIST_EMPLOYEE_SESSION: `${BASE_URL}/clock/listEmployeeSession`,
  UPDATE_EMPLOYEE_STATUS: `${BASE_URL}/clock/updateStatus`,
  MANUAL_CLOCK_IN: `${BASE_URL}/clock/manualClockSave`,
  DELETE_EMPLOYEE_SESSION: `${BASE_URL}/clock/deleteEmployeeSession`,
  LIST_DELETED_EMPLOYEE_SESSIONS: `${BASE_URL}/clock/listDeletedEmployeeSessions`,
  RESTORE_EMPLOYEE_SESSION: `${BASE_URL}/clock/restoreEmployeeSession`,
  DELETE_FOREVER_EMPLOYEE_SESSION: `${BASE_URL}/clock/deleteForeverEmployeeSession`,
};

export const GAME = {
  LIST_GAME: `${BASE_URL}/game/list`,
  EDIT_GAME: `${BASE_URL}/game/edit`,
};

export const NOTE = {
  LIST_NOTES: `${BASE_URL}/note/list`,
  ADD_NOTE: `${BASE_URL}/note/addNote`,
  DELETE_NOTE: `${BASE_URL}/note/deleteNote`,
};

export const RULES = {
  LIST_RULES: `${BASE_URL}/rule/list`,
  SAVE_RULES: `${BASE_URL}/rule/save`,
  CAMERA_SETTINGS: `${BASE_URL}/rule/cameraSettings`,
};

export const BONUS_API = {
  LIST_MANAGE_BONUS: `${BASE_URL}/bonus/list`,
  SAVE_MANAGE_BONUS: `${BASE_URL}/bonus/save`,
  DELETE_MANAGE_BONUS: `${BASE_URL}/bonus/delete`,
  TOGGLE_MANAGE_BONUS: `${BASE_URL}/bonus/toggleActive`,
  PREVIEW_BONUS_IMAGE: `${BASE_URL}/bonus/previewImage`,
  SAVE_BONUS: `${BASE_URL}/bonus/saveBonus`,
  DELETE_BONUS: `${BASE_URL}/bonus/deleteBonus`,
  LIST_CLAIM_BONUS: `${BASE_URL}/bonus/bonusList`,
  UPLOAD_BONUS_PHOTO: `${BASE_URL}/bonus/uploadBonusPhoto`,
  PENDING_PHOTOS: `${BASE_URL}/bonus/pendingPhotos`,
  REPORT_PHOTO_FAILURE: `${BASE_URL}/bonus/reportPhotoFailure`,
};

export const LOAN = {
  LIST_CUSTOMER_LOAN: `${BASE_URL}/loan/listCustomerLoan`,
  SAVE_CUSTOMER_LOAN: `${BASE_URL}/loan/saveCustomerLoan`,
  LIST_EMPLOYEE_LOAN: `${BASE_URL}/loan/listEmployeeLoan`,
  SAVE_EMPLOYEE_LOAN: `${BASE_URL}/loan/saveEmployeeLoan`,
  LIST_ZELLE_LOAN: `${BASE_URL}/loan/listZelleLoan`,
  SAVE_ZELLE_LOAN: `${BASE_URL}/loan/saveZelleLoan`,
};

export const AUDIT = {
  LIST_READING_SESSION_AUDIT: `${BASE_URL}/audit/listReadingSessionAudits`,
  LIST_WEEKLY_REPORT_AUDIT: `${BASE_URL}/audit/listWeeklyReportAudits`,
  LIST_CUSTOMER_POINT_AUDIT: `${BASE_URL}/audit/listCustomerPointAudits`,
};

export const MAINTENANCE_PERMIT = {
  GRANT: `${BASE_URL}/maintenancePermit/grant`,
  REVOKE: `${BASE_URL}/maintenancePermit/revoke`,
  CURRENT: `${BASE_URL}/maintenancePermit/current`,
  HISTORY: `${BASE_URL}/maintenancePermit/history`,
};

// Employee Session V2 — new endpoints introduced by the redesign (spec §11)
export const EMPLOYEE_SESSION_V2 = {
  LOAD_SESSION_REPORTS: `${BASE_URL}/report/getSessionReports`,
  LOAD_AUDIT_LOG: `${BASE_URL}/report/getAuditLog`,
  LOAD_OWNER_AUDIT_SETTINGS: `${BASE_URL}/report/getOwnerAuditSettings`,
  SAVE_OWNER_AUDIT_SETTINGS: `${BASE_URL}/report/saveOwnerAuditSettings`,
  LOAD_DUPLICATE_SCORES: `${BASE_URL}/report/getDuplicateScores`,

  EDIT_BONUS: `${BASE_URL}/bonus/editBonusV2`,
  DELETE_BONUS: `${BASE_URL}/bonus/deleteBonusV2`,
  ADD_BONUS: `${BASE_URL}/bonus/addBonusV2`,
  BONUS_DECISION: `${BASE_URL}/bonus/bonusDecision`,

  EDIT_RAFFLE: `${BASE_URL}/raffle/editRaffleV2`,
  DELETE_RAFFLE: `${BASE_URL}/raffle/deleteRaffleV2`,
  RAFFLE_DECISION: `${BASE_URL}/raffle/raffleDecision`,

  POINT_DECISION: `${BASE_URL}/report/pointDecision`,

  EDIT_TICKETOUT: `${BASE_URL}/ticketOut/editTicketOutV2`,
  DELETE_TICKETOUT: `${BASE_URL}/ticketOut/deleteTicketOutV2`,

  EDIT_TRANSACTION: `${BASE_URL}/transaction/editTransactionV2`,
  DELETE_TRANSACTION: `${BASE_URL}/transaction/deleteTransactionV2`,
  ADD_TRANSACTION: `${BASE_URL}/transaction/addTransactionV2`,

  EDIT_CASH_LEFT: `${BASE_URL}/transaction/editCashLeftV2`,
};

// NuVe Boost — full endpoint surface (audience, templates, credit,
// settings, admin, analytics, recharge, cancel + quick-send).
export const BOOST = {
  SEND: `${BASE_URL}/boost/send`,
  SEND_BULK: `${BASE_URL}/boost/sendBulk`,
  COST_ESTIMATE: `${BASE_URL}/boost/costEstimate`,
  SCHEDULE_AVAILABILITY: `${BASE_URL}/boost/scheduleAvailability`,
  RETRY_FAILED: `${BASE_URL}/boost/retryFailed`,
  RETRY_RECIPIENT: `${BASE_URL}/boost/retryRecipient`,
  CANCEL: `${BASE_URL}/boost/cancel`,
  LIST: `${BASE_URL}/boost/list`,
  HISTORY_PAGE: `${BASE_URL}/boost/historyPage`,
  DETAIL: `${BASE_URL}/boost/detail`,
  AUDIENCE_PREVIEW: `${BASE_URL}/boost/audiencePreview`,
  AUDIENCE_CUSTOMERS: `${BASE_URL}/boost/audienceCustomers`,
  CLEAR_INVALID_NUMBER: `${BASE_URL}/boost/clearInvalidNumber`,
  TEMPLATE_LIST: `${BASE_URL}/boost/templateList`,
  TEMPLATE_SAVE: `${BASE_URL}/boost/templateSave`,
  TEMPLATE_DELETE: `${BASE_URL}/boost/templateDelete`,
  CREDIT_STATUS: `${BASE_URL}/boost/creditStatus`,
  CREDIT_RECHARGE_INTENT: `${BASE_URL}/boost/creditRechargeIntent`,
  CREDIT_RECHARGE_SYNC: `${BASE_URL}/boost/creditRechargeSync`,
  SETTINGS_GET: `${BASE_URL}/boost/settingsGet`,
  SETTINGS_SAVE: `${BASE_URL}/boost/settingsSave`,
  ADMIN_GET: `${BASE_URL}/boost/adminGet`,
  ADMIN_SAVE: `${BASE_URL}/boost/adminSave`,
  ADMIN_RESET: `${BASE_URL}/boost/adminReset`,
  ADMIN_PAUSE: `${BASE_URL}/boost/adminPause`,
  ANALYTICS: `${BASE_URL}/boost/analytics`,
  PLATFORM_CONFIG_GET: `${BASE_URL}/boost/platformConfigGet`,
  PLATFORM_CONFIG_SAVE: `${BASE_URL}/boost/platformConfigSave`,
};

// Raffle module (Raffle 1 spec). No endpoint takes a winning number — the
// server draws it — and none deletes a raffle; mistakes are voided.
export const RAFFLE = {
  BOOTSTRAP: `${BASE_URL}/raffle/bootstrap`,
  CURRENT_RUN: `${BASE_URL}/raffle/currentRun`,
  HISTORY: `${BASE_URL}/raffle/history`,
  WINNERS: `${BASE_URL}/raffle/winners`,
  CUSTOMER_WINS: `${BASE_URL}/raffle/customerWins`,
  CUSTOMER_NUMBERS: `${BASE_URL}/raffle/customerNumbers`,
  SEARCH_CUSTOMERS: `${BASE_URL}/raffle/searchCustomers`,
  ADD_CUSTOMER: `${BASE_URL}/raffle/addCustomer`,
  SAVE_SETTINGS: `${BASE_URL}/raffle/saveSettings`,
  SAVE_DRAWING: `${BASE_URL}/raffle/saveDrawing`,
  DELETE_DRAWING: `${BASE_URL}/raffle/deleteDrawing`,
  SAVE_BOOK: `${BASE_URL}/raffle/saveBook`,
  DELETE_BOOK: `${BASE_URL}/raffle/deleteBook`,
  UPDATE_GIVEN_OUT: `${BASE_URL}/raffle/updateGivenOut`,
  CONFIRM_TICKETS: `${BASE_URL}/raffle/confirmTickets`,
  START_RUN: `${BASE_URL}/raffle/startRun`,
  DRAW: `${BASE_URL}/raffle/draw`,
  DISCARD_DRAW: `${BASE_URL}/raffle/discardDraw`,
  CLOSE_RUN: `${BASE_URL}/raffle/closeRun`,
  CARRY_POT: `${BASE_URL}/raffle/carryPot`,
  START_NEW_SERIES: `${BASE_URL}/raffle/startNewSeries`,
  PAY: `${BASE_URL}/raffle/pay`,
  EDIT_RAFFLE: `${BASE_URL}/raffle/editRaffle`,
  VOID_RAFFLE: `${BASE_URL}/raffle/voidRaffle`,
};

// Liveness probe used by AuthUtil to tell "the backend is down" apart
// from "this one request failed", and to notice recovery while the app
// is sitting there broken with nothing else in flight. Unauthenticated
// on purpose — an expired token must not read as an outage.
export const HEALTH = {
  PING: `${BASE_URL}/health/ping`,
};
